import { Avatar, Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { formatHelsinkiDateTime } from '../../common/dateHelper'
import { getRole } from '../../common/roleHelper'
import history from '../../history'
import { IListPerson } from '../../interfaces/persons/IPerson'
import { useStore } from '../../Provider'
import { scrollSaver } from '../common/scrollHelper'
import { MuiButtonVariants, OPButton } from '../OPcomponents/OPButton'
import { OPLoadMore } from '../OPcomponents/OPLoadMore'

import { Data, OPNewTable } from '../OPcomponents/OPNewTable'

const PersonsTable = (): JSX.Element => {
  const { t, i18n } = useTranslation()
  const rootStore = useStore()
  const { userPermission } = rootStore.loginStore
  const { filteredPersons } = rootStore.personStore
  const { resetPersonProfileOverview } = rootStore.profileStore
  const { stepperAmount } = rootStore.seachStore
  const [tableRows, setTableRows] = useState<Data[]>([])
  const [tableLength, setTableLength] = useState(10)

  const onRowClick = (id: number | string) => {
    scrollSaver(tableLength, rootStore)
    resetPersonProfileOverview()
    history.push('/persons/' + id)
  }

  const tableData = useMemo(() => {
    return filteredPersons.map((person) => {
      const formattedLastEdited = formatHelsinkiDateTime(person.lastEdited)

      return {
        ['id']: person.personId ?? -1,
        rows: {
          [t('Persons.Name')]: {
            text: (
              <Grid key={person.name} container alignItems='center' columnSpacing={2}>
                <Grid item>
                  <Avatar src={`data:image/jpeg;base64,${person.photo}`}></Avatar>
                </Grid>
                <Grid item>{person.name}</Grid>
              </Grid>
            ),
          },
          [t('Persons.Role')]: { text: getRole(person as IListPerson) ?? '' },
          [t('Profile.UserLastEditedShort')]: { text: formattedLastEdited },
          ...(userPermission && {
            [t('Persons.Actions')]: {
              text: (
                <OPButton
                  buttonVariant={MuiButtonVariants.primary_outlined}
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation() // Prevent row click when button is clicked
                    history.push(`/persons/${person.personId}/cv`)
                  }}
                  label={t('Buttons.DownloadCV')}
                />
              ),
            },
          }),
        },
      }
    })
  }, [filteredPersons, t, userPermission])

  return filteredPersons.length ? (
    <>
      <OPNewTable rows={tableData} curLength={tableLength} onRowClick={onRowClick} />
      <OPLoadMore
        startingStepper={stepperAmount}
        stepper={10}
        curLength={tableLength}
        maxLength={filteredPersons.length}
        filteredArray={filteredPersons}
        onLoadMore={(data) => setTableLength(data)}
      />
    </>
  ) : (
    <span className='profile--notfound'>{t('NotFound.NoResults')}</span>
  )
}

export default observer(PersonsTable)
